/* eslint-disable no-underscore-dangle */
/* eslint-disable arrow-parens */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
} from 'reactstrap';
import { RTLProps } from '@/shared/prop-types/ReducerProps';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useParams } from 'react-router';

const TransporterRoutes = ({ rtl }) => {
  const { t } = useTranslation('common');
  const [cookies, setCookie] = useCookies(['tranAuthToken']);

  const {
    data, isLoading, isFetching, isError,
  } = useQuery(
    'allTransporters',
    () => axios.get('https://orca-app-5i5qx.ondigitalocean.app/api/admin/transporter/list', {
      headers: {
        Authorization: `Bearer ${cookies.tranAuthToken}`,
      },
    }),
  );
  // if (data && !isLoading && !isFetching && !isError) {
  //   console.log('transporter', data.data);
  // }

    const { id } = useParams();
  // if (data && !isLoading && !isFetching && !isError) {
  //   console.log('transporter', data.data.routes[id].map((item, index) => (console.log(item.fromAddress, index))));
  // }
    if (data && !isLoading && !isFetching && !isError) {
    console.log('transporter rr', data.data.routes[id]);
  }
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
        
          <h3 className="page-title">Routes</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">Transporter Routes Of {parseInt(id, 10) + 1}</h5>


              </div>

              <Table responsive className="table--bordered">
                <thead>
    
                  <tr>
                    <th>From</th>
                    <th>To </th>
             
                  </tr>
                </thead>
                <tbody>
                  {isFetching && <tr><td>Loading...</td></tr>}
                  { !isFetching && !isLoading && !isError && data && data.data && data.data.routes && data.data.routes[id].map((item, index) => (
                    <tr key={item._id}>
                      <td>{item.fromAddress}</td>
                      <td>{item.toAddress}</td>
                    </tr>
                      ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

TransporterRoutes.propTypes = {
  rtl: RTLProps.isRequired,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(TransporterRoutes);
